import { useCallback, useState } from "react";
import { MotionConfig } from "framer-motion";
import "@/App.css";
import { ScrollProvider } from "@/lib/scroll";
import Preloader from "@/components/Preloader";
import Cursor from "@/components/Cursor";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Insight from "@/components/Insight";
import BeforeAfter from "@/components/BeforeAfter";
import Deliverables from "@/components/Deliverables";
import SelectedWork from "@/components/SelectedWork";
import ShootTypes from "@/components/ShootTypes";
import HorizontalBand from "@/components/HorizontalBand";
import WhoFor from "@/components/WhoFor";
import Process from "@/components/Process";
import Pricing from "@/components/Pricing";
import Programme from "@/components/Programme";
import Faq from "@/components/Faq";
import Enquiry from "@/components/Enquiry";
import Footer from "@/components/Footer";
import PlaceholderGuard from "@/components/PlaceholderGuard";
import Grain from "@/components/Grain";
import ScrollProgress from "@/components/ScrollProgress";
import { LegalProvider } from "@/components/Legal";

// Supply real films here to flip the Selected Work section into a live grid,
// e.g. [{ videoUrl, poster, title, location }]. Empty renders the private
// showcase treatment — no redesign needed.
const SELECTED_WORK_FILMS = [];

function App() {
  const [introDone, setIntroDone] = useState(false);
  const handleIntroDone = useCallback(() => setIntroDone(true), []);

  return (
    <MotionConfig reducedMotion="user">
      <ScrollProvider>
        <LegalProvider>
        <div className="bg-ground text-primaryText min-h-screen antialiased">
          <Preloader onDone={handleIntroDone} />
          <Cursor />
          <Nav />
          <ScrollProgress />
          <main>
            <Hero introDone={introDone} />
            {/* Warm ground scrolls over the fixed hero film */}
            <div className="relative z-10 bg-ground">
              <Insight />
              <BeforeAfter />
              <Deliverables />
              <SelectedWork films={SELECTED_WORK_FILMS} />
              <ShootTypes />
              <HorizontalBand />
              <WhoFor />
              <Process />
              <Pricing />
              <Programme />
              <Faq />
              <Enquiry />
              <Footer />
            </div>
          </main>
          <Grain />
          <PlaceholderGuard />
        </div>
        </LegalProvider>
      </ScrollProvider>
    </MotionConfig>
  );
}

export default App;
